import { MapPin } from 'lucide-react';
import { communes } from '@/mocks/communes';
import { useFadeUp } from '@/hooks/useFadeUp';

export function ZonesIntervention() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div ref={ref} className="fade-up max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Zones d'intervention</h2>
          <p className="section-subtitle">
            Nous intervenons à Charleroi et dans toutes les communes du Hainaut
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {communes.map((commune) => (
            <Link
              key={commune.slug}
              to={commune.urlPath}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 bg-primary-50 text-primary-600 hover:bg-accent-500 hover:text-white text-xs md:text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap"
            >
              <MapPin className="w-3.5 h-3.5" />
              {commune.name}
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/zones-dinterventions/"
            className="btn-outline text-sm px-6 py-2.5 inline-flex items-center gap-2"
          >
            Voir toutes les zones d'intervention
          </Link>
        </div>
      </div>
    </section>
  );
}